import React from 'react'
import Logo_path from '../../Components/Logo_path'

function ViewAdminDetails() {
  return (
    <div className='w-full h-full flex justify-center' style={{fontFamily: "Ropa Sans"}}>
        <div className='flex flex-col items-center w-full '>
           
           <div className='w-11/12 h-full'>
            <Logo_path AdminOrHome={'Admin'} Directory={'view admin'}/>
            
            <div className='flex justify-center w-full h-full -mt-16'>
            <div className='w-9/12 flex flex-col items-center'>
              <div className='w-6/12 '><button className='md:w-5/12 w-9/12 mt-5 rounded border bg-red-600 h-14 text-white'>Block</button></div>
              
              <div className='flex flex-row md:w-6/12 w-10/12 mt-10'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Name</div>
                <div className='w-6/12'></div>
              </div>

              <div className='flex flex-row md:w-6/12 w-10/12 mt-6'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Username</div>
                <div className='w-6/12'></div>
              </div>

              <div className='flex flex-row md:w-6/12 w-10/12 mt-6'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Email</div>
                <div className='w-6/12'></div>
              </div>

              <div className='flex flex-row md:w-6/12 w-10/12 mt-6 mb-4'>
                <div className='w-6/12 flex justify-start' style={{ color: '#606060' }}>Joining Date</div>
                <div className='w-6/12'></div>
              </div>

            </div>
            </div>
            
           </div>

        </div>
    </div>
  )
}

export default ViewAdminDetails